export default {"src":"https://cdn.jetlend.ru/_next/static/media/advantage-cup.d8041802.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};